import { AUDIO_NO_RESULT_LIGHT } from 'assets/images'

import * as Styled from './styled'

interface IProps {
  searchValue: string
}

export const AudioNoResult: React.FC<IProps> = ({ searchValue }) => {
  return (
    <Styled.AudioNoResult
      searchValue={searchValue}
      imgSrc={AUDIO_NO_RESULT_LIGHT}
    />
  )
}
